import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {RouterLinkSnackBarConfig} from '@aviary/store/snack-bar/snack-bar.types';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';

@Component({
  selector: 'mx-router-link-snack-bar',
  template: `
    @if (config.beforeLinkText; as beforeText) {
      <span>{{ beforeText }}</span>
    }

    <a [mxNamedRouterLink]="config.routeName" [mxNamedRouterLinkParams]="config.routeParams ?? {}" [mxQueryParams]="config.queryParams ?? {}"
       (click)="onClickRouterLink()" class="text-label-large uppercase">
      {{ config.linkText }}
    </a>

    @if (config.afterLinkText; as afterText) {
      <span>{{ afterText }}</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseNamedRouterLinkDirective]
})
export class RouterLinkSnackBarComponent {

  public config: RouterLinkSnackBarConfig = inject(MAT_SNACK_BAR_DATA);

  private snackBarRef: MatSnackBarRef<RouterLinkSnackBarComponent> = inject(MatSnackBarRef);

  public onClickRouterLink(): void {
    // Once the user has clicked the link, they are navigating away.  The snack bar has now served its purpose, so we cen dismiss it early.
    this.snackBarRef.dismiss();
  }
}
